import React from 'react';
import './card-list.styles.css';
import {Card} from '../card.component/card-component'
export const CardList = props => {
    // console.log(props);
    //now our app doesn't have to worry about creating the monster cards
    return (<div className='card-list'>
        {props.cats.map(cat => (
        <Card key={cat.id} cat={cat}/>
        ))}
    </div>)
}